/*
 * @Author: cuikj kaijun.cui@biz-united.com.cn
 * @Date: 2024-05-20 14:34:38
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-26 11:30:16
 * @Description:
 */
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import redPoolAccountCode from '../components/redPoolAccountName.vue';
import terminalDateTips from '../components/terminalDateTips.vue';

formCreate.component('redPoolAccountCode', redPoolAccountCode);
formCreate.component('terminalDateTips', terminalDateTips);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      formFunctionCode: 'main_form',
    };
  },
  mounted() {},
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'redPoolAccountCode') {
        v.value = {
          redPoolAccountName: '',
          redPoolAccountCode: '',
        };
        v.props = {
          ...v.props,
          poolAccountType: '2',
        };
        v.on = {
          ...v.on,
          change: (val) => {
            this.setValue({
              redPoolAccountCode: {
                redPoolAccountCode: val.poolAccountCode,
                redPoolAccountName: val.poolAccountName,
              },
              sourceType: val.sourceType,
              sourceTypeName: val.sourceTypeName,
              payChannel: val.payChannel,
              merchantId: val.merchantId,
            });
          },
        };
      }

      if (v.field === 'startDate') {
        v.props = {
          ...v.props,
          valueFormat: 'yyyy-MM-dd',
          type: 'daterange',
          rangeSeparator: '至',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期',
        };
        v.on = {
          ...v.on,
          change: (val) => {
            const d1 = new Date(val[0]);
            const d2 = new Date(val[1]);

            // 确保d1是较早的日期
            const start = d1 < d2 ? d1 : d2;
            const end = d1 < d2 ? d2 : d1;

            // 计算最大允许的结束日期（3个月后）
            const maxDate = new Date(start);
            maxDate.setMonth(start.getMonth() + 3);

            // 比较日期
            if (end > maxDate) {
              this.$message.warning('对账时间区间选择不能超过3个月');
              this.setValue({ startDate: [] });
            }
          },
        };
      }

      return v;
    },

    // 查询详情
    getDetail() {
      const { row } = this.formConfig;
      request
        .get('/tax/v1/cash/setting/taxRateRuleSetting/findById', { id: row.id })
        .then((res) => {
          const { success, result } = res;
          if (success) {
            let time = [];
            if (result.startTime && result.endTime) {
              time = [result.startTime.slice(0, 10), result.endTime.slice(0, 10)];
            }
            this.setValue({
              ...result,
              startTime: time,
              redPoolAccountName: {
                redPoolAccountName: result.redPoolAccountName,
                redPoolAccountCode: result.redPoolAccountCode,
              },
              contractSettingVos: result.contractSettingVos.map((item, index) => ({
                ...item,
                fileName: item.attachName,
                url: item.attachUrl,
              })),
            });
          }
        });
    },
    submit() {
      const formData = this.getFormData();
      if (formData) {
        const url = 'tax/v1/cash/record/check/consumerRecord/doConsumerDiff';
        const time = formData.startDate;
        const data = {
          ...formData,
          startDate: `${time[0]} 00:00:00`,
          endDate: `${time[1]} 23:59:59`,
          ...formData.redPoolAccountCode,
        };

        const tips = `${formData.redPoolAccountCode.redPoolAccountName}红包池正在统计${time[0]} - ${time[1]}的对账信息，请耐心等待几分钟！`;

        request.post(url, data).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.$emit('onClose');
            this.$emit('onGetList');
            this.$nextTick(() => {
              this.$confirm(tips, '提示', {
                confirmButtonText: '知道了',
                cancelButtonText: '',
                showCancelButton: false,
                type: 'warning',
              }).then(() => {});
            });
          }
        });
      }
    },
  },
};
